export const obterNomeOuNomeSocial = (integrante) => {

  if (integrante.temIdentidadeGenero && integrante.nomeSocialApelidoPessoa) {
      return integrante.nomeSocialApelidoPessoa;
  }

  return integrante.nomePessoa;
}
